/* =====================================================================
   wt-bundle.js — Essential Bundle PDP, on top of wt-fountain.js
   ---------------------------------------------------------------------
   assets/wt-fountain.js is the engine on this page too: it owns the colour
   selection (the swatches are its kit pills with a different skin), the
   gallery sync, the tiles, Total today, the add-on, WT_CART, the accordion,
   the dialogs and the sticky bar's mirror. Nothing below re-implements any
   of that.

   This file adds only what the bundle page has that the fountain page does
   not, and it always READS state from the buy box rather than keeping its
   own copy, so the two can never disagree:

     1. "What's included" clipped after N rows, with View More / View Less
     2. the Compare-sets card's add-on block: an on/off switch and a cadence
        picker that drive the real add-on controls, plus card prices that
        match Total today exactly
     3. the sticky bar's colour chip, title and thumbnail

   Every hook is delegated from `document` and every repaint is idempotent,
   because wt-bundle-buy-box.liquid moves its markup into the theme's product
   column and the theme editor can replace that markup at any time.
   ===================================================================== */
(function () {
  'use strict';

  if (window.__wtBundleJs) return;        /* boot + head both loaded it */
  window.__wtBundleJs = 1;

  /* Re-read on every use, never snapshotted. The theme editor re-renders the buy box
     and publishes a FRESH window.WT_BUNDLE, but this file is behind a run-once guard,
     so a captured copy would keep serving the pre-edit swatch colour, chip label or
     clip. wt-fountain.js re-reads WT_PRICING for the same reason. */
  function cfg() { return window.WT_BUNDLE || {}; }
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  function money(c)   { return '$' + (Number(c) / 100).toFixed(2); }
  function dollars(c) { return '$' + Math.round(Number(c) / 100); }

  /* ---------------- state, read from the buy box ---------------- */
  function pricing()  { return window.WT_PRICING || null; }
  function addonOn()  { var c = document.getElementById('filterCheck'); return !!(c && c.checked); }
  function planMode() {
    var m = $('.wtsel .fadd-mode.is-active');
    return m ? m.getAttribute('data-mode') : 'onetime';
  }
  function planId() {
    var sel = document.getElementById('filterFreq'), P = pricing();
    if (sel && sel.value) return sel.value;
    return P && P.filter ? P.filter.defaultFreq : null;
  }
  function plan() {
    var P = pricing();
    if (!P || !P.filter || !P.filter.plans) return null;
    return P.filter.plans[planId()] || null;
  }
  function subscribed() { return planMode() === 'sub' && !!plan(); }
  function kitCfg(key) {
    var kits = cfg().kits;
    return (kits && key) ? kits[key] : null;
  }
  function selectedKey() {
    var p = $('.wtsel .pills .pill.sel');
    if (p) return p.getAttribute('data-kit');
    var P = pricing();
    return P && P.kits ? Object.keys(P.kits)[0] : null;
  }

  /* ---------------- 1. View More --------------------------------
     The clip height is measured from the Nth row's bottom edge, so it always
     lands between rows however the copy wraps or the page is zoomed. */
  function moreBox() { return $('[id$="__main"] .wtmore') || $('.wtmore'); }

  function clipHeight(box) {
    var n = Number(cfg().clipAfter || 0);
    if (!n) return 0;
    var rows = $$('.tiles .tile', box).filter(function (t) { return !t.hidden; });
    if (rows.length <= n) return 0;                  /* nothing to hide */
    /* N whole rows, plus the depth of the gradient, so the N+1th row is half-visible
       UNDER the fade rather than the Nth row being faded out. The gradient's own
       height is measured, so CSS stays the single source of truth for it. */
    var fade = $('.wtmore-fade', box);
    var depth = fade ? fade.offsetHeight : 86;
    var top = box.getBoundingClientRect().top;
    var next = rows[n].getBoundingClientRect().top;
    return Math.max(0, Math.round(next - top + depth));
  }

  function measureMore() {
    var box = moreBox();
    if (!box) return;
    var h = clipHeight(box);
    if (!h) {                                        /* fewer rows than the clip: show everything */
      box.removeAttribute('data-wt-more-ready');
      box.classList.remove('is-clipped');
      box.style.removeProperty('--wtmore-h');
      return;
    }
    box.setAttribute('data-wt-more-ready', '');
    box.style.setProperty('--wtmore-h', h + 'px');
    if (!box.hasAttribute('data-wt-more-open')) box.classList.add('is-clipped');
  }

  function toggleMore() {
    var box = moreBox();
    if (!box) return;
    var btn = $('.wtmore-btn', box), lbl = $('.wtmore-lbl', box);
    var opening = box.classList.contains('is-clipped');
    if (opening) {
      box.setAttribute('data-wt-more-open', '');
      box.style.maxHeight = box.scrollHeight + 'px';
      box.classList.remove('is-clipped');
      /* let the transition finish, then stop constraining the box so a later
         reflow (a tile appearing, a font swapping in) is not clipped */
      setTimeout(function () { if (!box.classList.contains('is-clipped')) box.style.maxHeight = 'none'; }, 380);
    } else {
      box.removeAttribute('data-wt-more-open');
      box.style.maxHeight = box.scrollHeight + 'px';
      box.getBoundingClientRect();                   /* force the start frame */
      box.classList.add('is-clipped');
      box.style.maxHeight = '';
    }
    if (lbl) lbl.textContent = opening ? (cfg().lessLabel || 'View Less') : (cfg().moreLabel || 'View More');
    if (btn) btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
  }

  /* ---------------- 2. Compare-sets add-on ---------------------- */

  /* The same arithmetic wt-fountain.js does for Total today. Kept here rather
     than read off the DOM so a mid-render read can never show a stale number;
     if the two ever disagreed it would be a bug in one of them, not a rounding
     difference: both work in cents from WT_PRICING. */
  function totals(kitKey) {
    var P = pricing();
    if (!P || !P.kits) return null;
    var k = P.kits[kitKey] || P.kits[Object.keys(P.kits)[0]];
    if (!k) return null;
    var F = P.filter || {};
    var on = addonOn(), sub = subscribed();
    var charge = on ? (sub && plan() ? plan().first : F.base || 0) : 0;
    var now = k.price + charge;
    var tiers = P.tiers || {};
    /* `>=` with no truthiness test, exactly as wt-fountain.js does it: with the
       "Free mystery gift over" setting left blank Liquid emits 0, the engine then
       treats every order as qualifying, and a different test here would put a
       different compare-at price in the dialog than in Total today. */
    var qualifies = now >= (tiers.GIFT_MIN || 0);
    var was = k.was + (on ? (F.base || 0) : 0) + (qualifies ? (tiers.GIFT_VALUE || 0) : 0);
    return { now: now, was: was, on: on, sub: sub, qualifies: qualifies };
  }

  function paintCompare() {
    var cards = $$('#cmpModal .cmp-card');
    if (!cards.length) return;
    var freqMain = document.getElementById('filterFreq');
    cards.forEach(function (card) {
      var t = totals(card.getAttribute('data-kit'));
      if (!t) return;

      /* price line. wt-fountain.js writes this too (the kit price on its own);
         this runs after it and states the price the customer will actually be
         charged, add-on included. Same node shape, so nothing else shifts. */
      var kp = $('.cmp-kp', card);
      if (kp) {
        /* Compared against what is ON SCREEN, never against a value we remembered
           writing: wt-fountain.js rewrites this node on every one of its renders
           (a colour change, a cadence change), so a remembered value would match,
           the repaint would be skipped, and the dialog would sit there showing the
           set price without the add-on the customer had just switched on. */
        var want = money(t.now) + ' ' + dollars(t.was);
        var have = (kp.textContent || '').replace(/\s+/g, ' ').trim();
        if (have !== want) {
          kp.textContent = '';
          kp.appendChild(document.createTextNode(money(t.now) + ' '));
          var s = document.createElement('s');
          s.textContent = dollars(t.was);
          kp.appendChild(s);
        }
      }

      /* The fountain card also carries a "SAVE X%" badge that wt-fountain.js
         fills from the kit-only numbers; once the price line above includes the add-on,
         the pill must be the difference of the SAME two figures or the card contradicts
         itself ($109.98 / $200 next to "SAVE $60"). */
      /* the mystery-gift row: listed only while this card's order unlocks it (same
         threshold as the mystery tile in the buy box), bold on the selected card like
         the other rows that set it apart */
      var gift = $('.cmp-gift', card);
      if (gift) {
        if (gift.hidden !== !t.qualifies) gift.hidden = !t.qualifies;
        var giftBold = t.qualifies && card.classList.contains('cmp-card--sel');
        if (gift.classList.contains('cmp-diff') !== giftBold) gift.classList.toggle('cmp-diff', giftBold);
      }

      var pill = $('.cmp-pill', card);
      if (pill) {
        /* percentage badge beside the price (operator 2026-09-21), off the same two figures */
        var pillWant = t.was > t.now ? 'SAVE ' + Math.round((t.was - t.now) / t.was * 100) + '%' : '';
        if (pill.textContent !== pillWant) pill.textContent = pillWant;
      }

      var btn = $('.cmp-sub', card);
      var subbed = t.on && t.sub;
      if (btn) btn.setAttribute('aria-checked', subbed ? 'true' : 'false');
      var wrap = $('.cmp-subwrap', card);
      if (wrap) wrap.classList.toggle('is-on', subbed);

      /* "Subscribe & Save 15%" and "15% off first order, then 15% off recurring
         orders every 2 months": every number comes from the Seal plan the customer
         has picked. Both lines are repainted, not only the note - wt-fountain.js's
         own {pct} pass is scoped to .wtsel, and the modals code moves #cmpModal onto
         <body>, so nothing else can reach these two. */
      var p = plan();
      $$('.cmp-subnote[data-wt-tpl], .cmp-sub-t[data-wt-tpl]', card).forEach(function (el) {
        var txt = (el.getAttribute('data-wt-tpl') || '')
          .replace(/\{pct\}/g, String(p ? p.firstPct : 0))
          .replace(/\{renew\}/g, String(p ? p.pct : 0))
          .replace(/\{every\}/g, p ? (p.every || '') : '');
        if (el.textContent !== txt) el.textContent = txt;
      });

      var freq = $('.cmp-freq', card);
      if (freq && freqMain && freq.value !== freqMain.value) freq.value = freqMain.value;

      /* The unselected card's add-on is display:none, but a hidden <button>/<select>
         is still focusable, and the dialog's focus trap in wt-fountain.js picks the
         LAST focusable node - which was this hidden select, so Shift-Tab off the
         close button went nowhere. Disabled takes them out of that list. */
      var hidden = !card.classList.contains('cmp-card--sel');
      [btn, freq].forEach(function (el) {
        if (!el) return;
        if (el.disabled !== hidden) el.disabled = hidden;
      });
    });
  }

  /* Drive the REAL controls; never keep a second copy of the add-on state.
     Dispatching `change` is what wt-fountain.js listens for, so the drawer,
     Total today, WT_CART and this dialog all move together.

     Switching OFF removes the filter pack from the order altogether (owner
     decision 2026-09-21): the dialog's switch stands for "add the filters on a
     subscription", so off means no filters, and the price line above it drops
     back to the set alone. Switching ON adds the pack on the subscription mode. */
  var modeBefore = null;   /* the add-on mode the shopper had before the switch went ON */
  function setSubscription(on) {
    var check = document.getElementById('filterCheck');
    if (on) {
      var mode = $('.wtsel .fadd-mode[data-mode="sub"]');
      if (check && !check.checked) {
        check.checked = true;
        check.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (mode && !mode.classList.contains('is-active')) { modeBefore = planMode(); mode.click(); }
    } else {
      if (check && check.checked) {
        check.checked = false;
        check.dispatchEvent(new Event('change', { bubbles: true }));
      }
      /* a shopper who had One-time selected, tried the switch and turned it back off
         gets One-time back, so re-ticking the add-on row does not put them on a plan */
      if (modeBefore && modeBefore !== 'sub') {
        var back = $('.wtsel .fadd-mode[data-mode="' + modeBefore + '"]');
        if (back && !back.classList.contains('is-active')) back.click();
      }
      modeBefore = null;
    }
    schedule();
  }

  function setFrequency(value) {
    var sel = document.getElementById('filterFreq');
    if (!sel || sel.value === value) return;
    sel.value = value;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    schedule();
  }

  /* ---------------- 3. Sticky bar ------------------------------
     The bar's title and thumbnail carry data-wtsb="ttl-b" / "img-b" so
     wt-fountain.js's mirror (which looks for "ttl" / "img" and would paste the
     first included row's name and picture in) leaves them alone: on this page
     they are the product, not the row. Everything else in the bar — price,
     compare-at, SAVE, gifts, delivery, rating — is still the engine's. */
  function paintSticky() {
    var bar = document.getElementById('wt-sticky-atc');
    if (!bar) return;
    var key = selectedKey();
    var sw = kitCfg(key);
    if (!sw) return;
    $$('[data-wtsb="variant"]', bar).forEach(function (el) {
      if (el.textContent !== sw.chip) el.textContent = sw.chip;
    });
    $$('.wtsb-cdot', bar).forEach(function (d) {
      /* Compared against what we last WROTE: reading style.backgroundColor gives
         "rgb(176, 176, 176)" for a "#b0b0b0" write, so that comparison never
         matched and the write ran on every repaint. */
      if (d.getAttribute('data-wt-dot') === sw.color) return;
      d.setAttribute('data-wt-dot', sw.color);
      d.style.background = sw.color;
    });
    if (sw.img) {
      $$('[data-wtsb="img-b"]', bar).forEach(function (img) {
        if (img.getAttribute('src') !== sw.img) img.setAttribute('src', sw.img);
      });
    }
  }

  /* The one included row that is colour-specific (the mat): its name and picture
     follow the swatch, the way the fountain row follows the selected kit in
     wt-fountain.js. Everything else on the row - worth, price - is the same for
     both colours, so it is left exactly as Liquid rendered it. */
  function paintColorRow() {
    var row = $('[id$="__main"] .tile[data-wt-color-row]') || $('.tile[data-wt-color-row]');
    if (!row) return;
    var key = selectedKey();
    var sw = kitCfg(key);
    if (!sw) return;
    var name = $('.tname', row);
    if (name && sw.rowName && name.textContent !== sw.rowName) name.textContent = sw.rowName;
    var img = $('.timg img', row);
    if (img && sw.rowImg && img.getAttribute('src') !== sw.rowImg) {
      img.setAttribute('src', sw.rowImg);
      if (sw.rowName) img.setAttribute('alt', sw.rowName);
    }
  }

  /* ---------------- 4. the cart line's drawer labels ----------------
     wt-fountain.js names the line after the selected KIT ("EverMount - Starter
     Kit"), which is right on the fountain page. Here the kits are colours, so
     the same code would put "EverMount - Gray" in the drawer and drop the
     product. The labels are settings on each colour; this restates them on
     WT_CART, which is what wt-evermount-gifts.js posts with the line.

     Applied on every repaint AND in a capture-phase submit listener, because
     the submit is the only moment that actually matters and wt-bundle.js is
     loaded before the gift script, so this runs first. */
  function stampCart() {
    var c = window.WT_CART;
    if (!c || !c.kit) return;
    var key = selectedKey();
    var sw = kitCfg(key);
    if (!sw || !sw.cartTitle) return;
    var props = c.kit.properties || {};
    if (props._wt_kit_name === sw.cartTitle && props._wt_kit_sub === (sw.cartSub || '')) return;
    props._wt_kit_name = sw.cartTitle;
    props._wt_kit_sub = sw.cartSub || '';
    c.kit.properties = props;
  }
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) stampCart();
  }, true);

  /* ---------------- repaint scheduling --------------------------
     wt-fountain.js renders synchronously inside its own listeners, which are
     bound on the elements themselves; the delegated listeners below therefore
     see the page AFTER it has rendered. The rAF is belt and braces for the
     paths that render asynchronously (a theme-editor re-render). */
  var raf = 0;
  function repaint() { raf = 0; paintCompare(); paintSticky(); paintColorRow(); stampCart(); }
  function schedule() {
    if (raf) return;
    raf = (window.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(repaint);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var sub = e.target.closest('#cmpModal .cmp-sub');
    if (sub) {
      e.preventDefault();
      e.stopPropagation();                 /* the dialog must not close under the switch */
      setSubscription(!(addonOn() && subscribed()));
      return;
    }
    if (e.target.closest('#cmpModal .cmp-freq')) { e.stopPropagation(); return; }

    if (e.target.closest('.wtmore-btn')) { toggleMore(); return; }

    /* colour swatch / add-on mode: wt-fountain.js has already re-rendered by
       the time this bubbles up, so only the extras need repainting */
    if (e.target.closest('.wtsel .pill, .wtsel .fadd-mode')) schedule();
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.classList && t.classList.contains('cmp-freq')) { setFrequency(t.value); return; }
    if (t.id === 'filterCheck' || t.id === 'filterFreq') schedule();
  });

  /* The switch is a real control: space and enter must work on it, and the
     dialog's own key handling must not see them. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Enter') return;
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('#cmpModal .cmp-sub')) return;
    e.preventDefault();
    e.stopPropagation();
    setSubscription(!(addonOn() && subscribed()));
  }, true);

  /* Backstop: anything that changes Total today without going through a
     control above (the engine's own first render, a price re-wrap) repaints
     the dialog too. Only reads; it never writes to what it observes. */
  function watchTotal() {
    var tot = document.getElementById('totNow');
    if (!tot || !window.MutationObserver || tot.__wtBundleWatched) return;
    tot.__wtBundleWatched = 1;
    new MutationObserver(schedule).observe(tot, { childList: true, characterData: true, subtree: true });
  }

  function init() {
    measureMore();
    watchTotal();
    repaint();
  }

  /* wt-bundle-buy-box.liquid fires this once its markup is in the product
     column, and again after every theme-editor re-render. */
  document.addEventListener('wt:buy-box-ready', function () { setTimeout(init, 0); });
  document.addEventListener('wt:price-rewrapped', schedule);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', function () { measureMore(); schedule(); });

  /* The clip is a pixel height, so it has to be re-measured whenever the rows
     can change height: resize, zoom band change, font swap, a tile appearing
     (the mystery-gift row crossing its threshold). */
  var mraf = 0;
  function remeasure() {
    if (mraf) return;
    mraf = (window.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(function () {
      mraf = 0;
      measureMore();
    });
  }
  window.addEventListener('resize', remeasure);
  window.addEventListener('orientationchange', remeasure);
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) document.fonts.ready.then(remeasure);
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(remeasure);
    function watchBox() {
      var b = moreBox();
      /* disconnect first: a theme-editor re-render replaces the node, and observing
         the new one without dropping the old keeps every detached copy alive */
      ro.disconnect();
      if (b) ro.observe(b);
    }
    watchBox();
    document.addEventListener('wt:buy-box-ready', watchBox);
  }
})();
